import Paths from './Paths';

export const pathsOnlyForUnauthorized: string[] = [
  Paths.Registration,
  Paths.Login,
];

export default pathsOnlyForUnauthorized;